import { Box } from '@mui/material';

export default function ModalSlider(props) {
  const { steps, activeStep, width = 500 } = props;

  return (
    <Box sx={{ width, overflow: 'hidden', position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          width: `${steps.length * 100}%`,
          transform: `translateX(-${activeStep * (100 / steps.length)}%)`,
          transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        {steps.map((step, idx) => (
          <Box
            key={idx}
            sx={{ width: `${100 / steps.length}%`, flexShrink: 0 }}
          >
            {step}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
